/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

export const GET_AGENTIC_GRAPHS = 'GET_AGENTIC_GRAPHS';
export const GET_AGENTIC_GRAPHS_SUCCESS = 'GET_AGENTIC_GRAPHS_SUCCESS';
export const GET_AGENTIC_GRAPHS_ERROR = 'GET_AGENTIC_GRAPHS_ERROR';

export const GET_AGENTIC_GRAPH = 'GET_AGENTIC_GRAPH';
export const GET_AGENTIC_GRAPH_SUCCESS = 'GET_AGENTIC_GRAPH_SUCCESS';
export const GET_AGENTIC_GRAPH_ERROR = 'GET_AGENTIC_GRAPH_ERROR';

export const GET_AGENTIC_PROMPT_VERSIONS = 'GET_AGENTIC_PROMPT_VERSIONS';
export const GET_AGENTIC_PROMPT_VERSIONS_SUCCESS = 'GET_AGENTIC_PROMPT_VERSIONS_SUCCESS';
export const GET_AGENTIC_PROMPT_VERSIONS_ERROR = 'GET_AGENTIC_PROMPT_VERSIONS_ERROR';

export const GET_AGENTIC_PROMPT_VERSION = 'GET_AGENTIC_PROMPT_VERSION';
export const GET_AGENTIC_PROMPT_VERSION_SUCCESS = 'GET_AGENTIC_PROMPT_VERSION_SUCCESS';
export const GET_AGENTIC_PROMPT_VERSION_ERROR = 'GET_AGENTIC_PROMPT_VERSION_ERROR';

export const UPDATE_AGENTIC_PROMPT = 'UPDATE_AGENTIC_PROMPT';
export const UPDATE_AGENTIC_PROMPT_SUCCESS = 'UPDATE_AGENTIC_PROMPT_SUCCESS';
export const UPDATE_AGENTIC_PROMPT_ERROR = 'UPDATE_AGENTIC_PROMPT_ERROR';

export const GET_PROMPT_CATALOGUE = 'GET_PROMPT_CATALOGUE';
export const GET_PROMPT_CATALOGUE_SUCCESS = 'GET_PROMPT_CATALOGUE_SUCCESS';
export const GET_PROMPT_CATALOGUE_ERROR = 'GET_PROMPT_CATALOGUE_ERROR';

export const CREATE_AGENTIC_PROMPT = 'CREATE_AGENTIC_PROMPT';
export const CREATE_AGENTIC_PROMPT_SUCCESS = 'CREATE_AGENTIC_PROMPT_SUCCESS';
export const CREATE_AGENTIC_PROMPT_ERROR = 'CREATE_AGENTIC_PROMPT_ERROR';

export const GET_PROMPT_NAME_AVAILABILITY = 'GET_PROMPT_NAME_AVAILABILITY';
export const GET_PROMPT_NAME_AVAILABILITY_SUCCESS = 'GET_PROMPT_NAME_AVAILABILITY_SUCCESS';
export const GET_PROMPT_NAME_AVAILABILITY_ERROR = 'GET_PROMPT_NAME_AVAILABILITY_ERROR';

export const GET_PROMPT_VERSION_GRAPHS = 'GET_PROMPT_VERSION_GRAPHS';
export const GET_PROMPT_VERSION_GRAPHS_SUCCESS = 'GET_PROMPT_VERSION_GRAPHS_SUCCESS';
export const GET_PROMPT_VERSION_GRAPHS_ERROR = 'GET_PROMPT_VERSION_GRAPHS_ERROR';

export const GET_AGENTIC_PROMPT_HISTORY = 'GET_AGENTIC_PROMPT_HISTORY';
export const GET_AGENTIC_PROMPT_HISTORY_SUCCESS = 'GET_AGENTIC_PROMPT_HISTORY_SUCCESS';
export const GET_AGENTIC_PROMPT_HISTORY_ERROR = 'GET_AGENTIC_PROMPT_HISTORY_ERROR';
